export const TYPES = {
  StaffMemberFactory: Symbol.for('StaffMemberFactory'),
};